import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  CircularProgress,
  Button,
} from "@mui/material";
import AssessmentSection from "./AssessmentSection";
import {
  createStudentsAPIEndpoint,
  EndPoints,
} from "../../../../services/StudentAPIs";
import SummaryCard from "./SummaryCard";

function StudentMonthlyReport({ studentId, year, month }) {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const reportRef = useRef(null);
  useEffect(() => {
    fetchReport();
  }, [studentId, year, month]);

  const fetchReport = async () => {
    try {
      setLoading(true);

      const res = await createStudentsAPIEndpoint(
        EndPoints.getMonthlyStudentReport(studentId, year, month),
      ).fetch();

      setReport(res.data);
    } catch (error) {
      console.error("Failed to fetch report:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box className="report-loading">
        <CircularProgress />
      </Box>
    );
  }

  if (!report) {
    return (
      <Box className="report-empty">
        <Typography>لا يوجد تقرير متاح لهذا الشهر</Typography>
      </Box>
    );
  }

  return (
    <>
      <div className="report-actions no-print">
        <Button
          className="export-pdf-btn"
          variant="outlined"
          onClick={() => window.print()}
        >
          Export PDF
        </Button>
      </div>

      <div className="student-monthly-report">{/* التقرير كله هنا */}</div>
      <div ref={reportRef} className="student-monthly-report">
        <Box className="student-monthly-report" dir="rtl">
          {/* Header */}
          <Box className="report-header">
            <Typography variant="h4" className="report-title">
              تقرير الأداء الشهري
            </Typography>

            <Typography className="report-period">
              {report.period.monthName} {report.period.year}
            </Typography>
          </Box>

          {/* Student Info */}
          <Card className="report-student-card">
            <CardContent>
              <Grid container spacing={7}>
                <Grid item xs={12} md={6}>
                  <Typography className="info-label">اسم الطالب</Typography>

                  <Typography className="info-value">
                    {report.student.studentName}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography className="info-label">السنتر</Typography>

                  <Typography className="info-value">
                    {report.student.centerName || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Summary */}
          <Typography className="section-title">ملخص الأداء</Typography>

          <Grid container spacing={2}>
            <SummaryCard
              title="إجمالي الاختبارات والواجبات"
              value={report.summary.totalAssessments}
            />

            <SummaryCard title="تم الحل" value={report.summary.completed} />

            <SummaryCard
              title="لم يحضر / لم يسلم"
              value={report.summary.missed}
            />

            <SummaryCard
              title="نسبة الالتزام"
              value={`${report.summary.participationRate}%`}
            />

            <SummaryCard
              title="متوسط الدرجات"
              value={`${report.summary.averageScore}%`}
            />
          </Grid>

          {/* Exams */}
          <AssessmentSection title="الاختبارات" items={report.exams} />
          {/* Homeworks */}
          <AssessmentSection title="الواجبات" items={report.homeworks} />

          {/* Comment */}
          <Card className="report-comment">
            <CardContent>
              <Typography className="section-title">ملاحظات</Typography>

              <Typography className="comment-text">{report.comment}</Typography>
            </CardContent>
          </Card>
        </Box>
      </div>
    </>
  );
}
export default StudentMonthlyReport;
